import React, { Component } from 'react';
import Block from '../block';
import { RichText } from '../richTextOptions';
import Accordion from 'react-bootstrap/Accordion';
import Slider from 'react-slick';

const BlockContainer = ({ block }) => {
     return (
          <>
               {block.blocks &&
                    block.blocks.map((block, i) => {
                         return <Block block={block} key={i}></Block>
                    })}
          </>
     )
}

class BlockContainerFaq extends Component {
     constructor(props) {
          super(props);

          this.state = {
               activeFaqIndex: '',
          }
     }

     setActiveFaqIndex = (index) => this.setState({ activeFaqIndex: index })

     toggleDiv = (id, status) => {
          $('.collapse').map(function () {
               if (id == $(this).attr('id')) {
                    (status) ? $(this).slideUp() : $(this).slideDown()
               } else {
                    $(this).slideUp()
               }
          })
     }

     render() {
          const { block } = this.props;

          return (
               <Accordion>
                    {block.blocks &&
                         block.blocks.map((block, i) => {
                              let newBlock = block;
                              newBlock.btnActive = false
                              if (this.state.activeFaqIndex === i) {
                                   newBlock.btnActive = true
                                   return (
                                        <div className="faq active" key={i}>
                                             <Block block={newBlock} onClick={() => this.setActiveFaqIndex('')}></Block>
                                        </div>
                                   )
                              }

                              return (
                                   <div className="faq" key={i}>
                                        <Block block={newBlock} onClick={() => this.setActiveFaqIndex(i)}></Block>
                                   </div>
                              )
                         })}
               </Accordion>

          )
     }
}

const BlockContainer2Column = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-md-6 content-left">
                         <Block block={col0}></Block>

                    </div>
               )}
               {col1 != null && (
                    <div className="col-md-6 content-right">
                         <Block block={col1}></Block>
                    </div>
               )}
          </div>
     )
}

const BlockContainer2Column57 = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-md-5">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-md-7">
                         <Block block={col1}></Block>
                    </div>
               )}
          </div>
     )
}

const BlockContainer2Column75 = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-lg-7">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-lg-5">
                         <Block block={col1}></Block>
                    </div>
               )}
          </div>
     )
}

const BlockContainer2Column57Lg = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-lg-5">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-lg-7">
                         <Block block={col1}></Block>
                    </div>
               )}
          </div>
     )
}

const BlockContainer2Column84 = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-lg-8">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-lg-4">
                         <Block block={col1}></Block>
                    </div>
               )}
          </div>
     )
}

const BlockContainer2Column48 = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-lg-4">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-lg-8">
                         <div className="content-right">
                              <Block block={col1}></Block>
                         </div>
                    </div>
               )}
          </div>
     )
}

const BlockContainer2Column48Md = ({ block }) => {

     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-md-4">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-md-8">
                         <div className="content-right">
                              <Block block={col1}></Block>
                         </div>
                    </div>
               )}
          </div>
     )
}

const BlockContainer3Column = ({ block }) => {
     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     var col2 = typeof block.blocks[2] != 'undefined' ? block.blocks[2] : null
     return (
          <div className="row">
               {col0 != null && (
                    <div className="col-lg-4">
                         <Block block={col0}></Block>
                    </div>
               )}
               {col1 != null && (
                    <div className="col-lg-4">
                         <Block block={col1}></Block>
                    </div>
               )}
               {col2 != null && (
                    <div className="col-lg-4">
                         <Block block={col2}></Block>
                    </div>
               )}
          </div>
     )
}

const BlockContainer3ColumnHeader = ({ block }) => {
     var col0 = typeof block.blocks[0] != 'undefined' ? block.blocks[0] : null
     var col1 = typeof block.blocks[1] != 'undefined' ? block.blocks[1] : null
     var col2 = typeof block.blocks[2] != 'undefined' ? block.blocks[2] : null
     var col3 = typeof block.blocks[3] != 'undefined' ? block.blocks[3] : null
     return (
          <div className="container">
               <Block block={col0}></Block>
               <div className="row">
                    {col1 != null && (
                         <div className="col-lg-4">
                              <Block block={col1}></Block>
                         </div>
                    )}
                    {col2 != null && (
                         <div className="col-lg-4">
                              <Block block={col2}></Block>
                         </div>
                    )}
                    {col3 != null && (
                         <div className="col-lg-4">
                              <Block block={col3}></Block>
                         </div>
                    )}
               </div>
          </div>
     )
}

const BlockContainer4Columns = ({ block }) => {
     return (
          <div className="container container-4-column">
               {
                    block.headerDescription && (
                         <div className="headline">
                              <RichText data={block.headerDescription}></RichText>
                         </div>
                    )
               }
               <div className="row">
                    {
                         Array.isArray(block?.blocks) && block.blocks.map((block, index) => (
                              <div key={index} className="col-md-6 col-lg-3">
                                   <Block block={block}></Block>
                              </div>
                         ))
                    }
               </div>
          </div>
     )
}

const BlockContainerNColumns = ({ block }) => {
     return (
          <div className="container n-column">
               {
                    block.headerDescription && (
                         <div className="headline">
                              <RichText data={block.headerDescription}></RichText>
                         </div>
                    )
               }
               <div className="row">
                    {
                         Array.isArray(block?.blocks) && block.blocks.map((block, index) => (
                              <div key={index} className="col-lg">
                                   <Block block={block}></Block>
                              </div>
                         ))
                    }
               </div>
          </div>
     )
}

const BlockContainerNRows3Columns = ({ block }) => {
     return (
          <div className="container">
               {
                    block.headerDescription && (
                         <div className="headline">
                              <RichText data={block.headerDescription}></RichText>
                         </div>
                    )
               }
               <div className="row">
                    {
                         Array.isArray(block?.blocks) && block.blocks.map((block, index) => (
                              <div key={index} className="col-4">
                                   <div className="col-content">
                                        <Block block={block}></Block>
                                   </div>
                              </div>
                         ))
                    }
               </div>
          </div>
     )
}

const BlockContainerNRows3ColumnsSlide = ({ block }) => {
     const settings = {
          dots: false,
          arrows: true,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
               {
                    breakpoint: 991,
                    settings: {
                         slidesToShow: 2,
                         arrows: false,
                         dots: true,
                    }
               },
               {
                    breakpoint: 575,
                    settings: {
                         slidesToShow: 1,
                         arrows: false,
                         dots: true,
                         variableWidth: true
                    }
               }
          ],
     };
     return (
          <div className="container">
               {
                    block.headerDescription && (
                         <div className="headline">
                              <RichText data={block.headerDescription}></RichText>
                         </div>
                    )
               }
               <Slider {...settings}>
                    {Array.isArray(block?.blocks) && block.blocks.map((block, index) => (
                         <div key={index} className="block-slide-col">
                              <div className="col-content">
                                   <Block block={block}></Block>
                              </div>
                         </div>
                    ))}
               </Slider>
          </div>
     )
}

const ContentfulBlockContainer = block => {
     var content = '';

     if (block.blocks != null) {
          switch (block.containerStyle) {
               case 'NoFull-Nocolumn-Faq':
                    content = (
                         <BlockContainerFaq block={block}></BlockContainerFaq>
                    )
                    break;
               case '2-Column':
                    content = (
                         <BlockContainer2Column block={block}></BlockContainer2Column>
                    )
                    break;
               case '2-Column-5/7':
                    content = (
                         <BlockContainer2Column57 block={block}></BlockContainer2Column57>
                    )
                    break;
               case '2-Column-7/5':
                    content = (
                         <BlockContainer2Column75 block={block}></BlockContainer2Column75>
                    )
                    break;
               case '2-Column-8/4':
                    content = (
                         <BlockContainer2Column84 block={block}></BlockContainer2Column84>
                    )
                    break;
               case '2-Column-4/8':
                    content = (
                         <BlockContainer2Column48 block={block}></BlockContainer2Column48>
                    )
                    break;
               case '2-Column-4/8-md':
                    content = (
                         <BlockContainer2Column48Md block={block}></BlockContainer2Column48Md>
                    )
                    break;
               case '3-Column':
                    content = (
                         <BlockContainer3Column block={block}></BlockContainer3Column>
                    )
                    break;
               case '3-Column-Header':
                    content = (
                         <BlockContainer3ColumnHeader block={block}></BlockContainer3ColumnHeader>
                    )
                    break;
               case '4-Column':
                    content = (
                         <BlockContainer4Columns block={block}></BlockContainer4Columns>
                    )
                    break;
               case 'n-Column':
                    content = (
                         <BlockContainerNColumns block={block}></BlockContainerNColumns>
                    )
                    break;
               case 'n-Rows-3-Columns':
                    content = (
                         <BlockContainerNRows3Columns block={block}></BlockContainerNRows3Columns>
                    )
                    break;
               case 'n-Rows-3-Columns-Slide':
                    content = (
                         <BlockContainerNRows3ColumnsSlide block={block}></BlockContainerNRows3ColumnsSlide>
                    )
                    break;
               case '2-Column-5/7-lg':
                    content = (
                         <BlockContainer2Column57Lg block={block}></BlockContainer2Column57Lg>
                    )
                    break;
               default:
                    content = (
                         <BlockContainer block={block}></BlockContainer>
                    )
                    break;
          }
     }

     let layoutClass = block.layoutTemplate ? block.layoutTemplate.replace(/ /g, '-').toLowerCase() : null
     let blockClass = block.containerClass ? block.containerClass : null;
     let backgroundPosition = block.backgroundPosition ? 'background-position ' + block.backgroundPosition.replace(/ /g, '-').toLowerCase() : null;
     let backgroundImageUrl = null;

     if (block.backgroundImage) {
          backgroundImageUrl = `url(${block.backgroundImage.fields ? block.backgroundImage.fields.file.url : block.backgroundImage.file.url})`;
     }

     if (backgroundPosition) {
          if (blockClass) {
               blockClass += ' ' + backgroundPosition;
          } else {
               blockClass = backgroundPosition;
          }
     }

     if (layoutClass && blockClass) {
          blockClass = blockClass + ' ' + layoutClass;
     } else if (!blockClass) {
          blockClass = layoutClass;
     }

     return (
          <div className={blockClass || layoutClass} style={{ backgroundImage: backgroundImageUrl, backgroundColor: block.backgroundColor, color: block.textColor, '--section-color': block.textColor, }}>
               {block.headerTitle && <div className="headline"><span>{block.headerTitle}</span></div>}
               {block.headerDescription && <RichText data={block.headerDescription}></RichText>}
               {content}
          </div>
     )
}

export {
     ContentfulBlockContainer,
     BlockContainerFaq
}
